declare global {
	interface Window {
		useRTExperiments: undefined | (() => void);
		unUseRTExperiments: undefined | (() => void);
	}
}

let created: boolean;
const paths: string[] = [];

/**
 * Add an experiment to the list of experiments to load.
 *
 * @param fileName The name of the file to load.
 */
export function addExperiment(fileName: string): void {
	if (!created) {
		init();
	}
	paths.push(fileName);
}

/** Initializes the experiments. */
function init() {
	window.useRTExperiments = () => {
		const head = document.head;
		for (const path of paths) {
			const element = isJS(path) ? "script" : "link";

			let tag;

			if (element == "script") {
				tag = document.createElement("script");
				tag.type = "text/javascript";
				tag.src = "/wp-content/themes/rootree/dist/" + path;
			} else {
				tag = document.createElement("link");
				tag.type = "text/css";
				tag.href = "/wp-content/themes/rootree/dist/" + path;
				tag.rel = "stylesheet";
			}
			head.appendChild(tag);
		}
	};

	window.unUseRTExperiments = () => {
		if ("useRTExperiments" in window) {
			delete window.useRTExperiments;
		}
		created = false;
	};
	created = true;
}

/**
 * Determines if the path is a JavaScript file.
 *
 * @param path The path to check.
 * @returns True if the path is a JavaScript file, false otherwise.
 */
function isJS(path: string) {
	return path.endsWith(".js");
}
